import React from "react";
import "./statusCard.css";

const StatusCard = (props) => {
  return (
    <div className={props.newSeasonAllowed ? "statusCard" : "statusCard__no__effect"}>
      <div className="statusCard__icon">
        <i className={props.icon}></i>
      </div>
      <div className="statusCard__info">
        <h4>{props.count}</h4>
        <span>{props.title}</span>
      </div>
    </div>
  );
};

export default StatusCard;
